<template>
  <div
    class="ui-rate"
    @mouseleave="selectRate(value)">
    <p
      v-if="title"
      class="ui-rate__title">
      {{ title }}
    </p>

    <div
      class="ui-rate__block"
      :class="{'ui-rate__block--margin': !!title}">
      <ul class="ui-rate__stars">
        <li
          v-for="number in maxRate"
          :key="number"
          :class="{
            'ui-rate__star--hovered': !isReadOnly
          }"
          class="ui-rate__star"
          @mouseenter="selectRate(number)"
          @click="setRate(number)">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient
                :id="`linear-gradient-${number}-${starKey}`"
                class="ui-rate__star-gradient">
                <stop
                  :offset="getFillPosition(number).start"
                  stop-color="var(--icon-start-color)" />
                <stop
                  :offset="getFillPosition(number).stop"
                  stop-color="var(--icon-end-color)" />
              </linearGradient>
            </defs>

            <!-- eslint-disable -->
            <path
              :fill="`url(#linear-gradient-${number}-${starKey})`"
              d="M23.965 9.246a.703.703 0 00-.567-.478l-7.44-1.081L12.63.945a.703.703 0 00-1.26 0L8.042 7.687l-7.44 1.08a.703.703 0 00-.39 1.2l5.384 5.248-1.27 7.41a.703.703 0 001.02.741L12 19.868l6.654 3.498a.703.703 0 001.02-.74l-1.27-7.411 5.384-5.248a.703.703 0 00.177-.72z" />
            <!-- eslint-enable -->
          </svg>
        </li>
      </ul>

      <p
        v-if="shouldShowRateDescription"
        class="ui-rate__rate-descriptions">
        <span>Poor</span>

        <span>Excellent</span>
      </p>
    </div>

    <span
      v-if="showRateNumber && selectedRate"
      class="ui-rate__rate">
      {{ selectedRate.toFixed(1) }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'UiRate',

  props: {
    title: {
      type: String,
      default: null,
    },

    value: {
      type: Number,
      default: null,
    },

    maxRate: {
      type: Number,
      default: 5,
    },

    isReadOnly: {
      type: Boolean,
      default: false,
    },

    showRateNumber: {
      type: Boolean,
      default: true,
    },

    shouldShowRateDescription: {
      type: Boolean,
      default: false,
    },

    starKey: {
      type: [String, Number],
      default: Date.now(),
    },
  },

  data() {
    return {
      selectedRate: this.value,
    };
  },

  watch: {
    value(newValue) {
      if (newValue !== this.selectedRate) {
        this.selectedRate = newValue;
      }
    },
  },

  methods: {
    setRate(rate) {
      if (this.isReadOnly || !rate) {
        return;
      }

      this.$emit('input', rate);
    },

    selectRate(rate = null) {
      if (this.isReadOnly) {
        return;
      }

      this.selectedRate = rate;
    },

    getFillPosition(number) {
      let start = 0;
      let stop = 0;

      if (number <= Math.floor(this.selectedRate)) {
        start = 100;
        stop = 100;
      } else if (Math.ceil(this.selectedRate) === number) {
        const position = Math.round((this.selectedRate % Math.floor(this.selectedRate)) * 100);

        start = position;
        stop = position + 1;
      }

      return { start: `${start}%`, stop: `${stop}%` };
    },
  },
};
</script>

<style lang="scss" scoped>
  .ui-rate {
    //--star-size: 24px;

    display: flex;
    align-items: center;
    font-size: 19px;
    line-height: 1.2;
    font-weight: 500;
  }

  .ui-rate__block--margin {
    margin: 0 8px 0 24px;
  }

  .ui-rate__stars {
    position: relative;
    display: grid;
    grid-auto-flow: column;
    grid-gap: 8px;
  }

  .ui-rate__star {
    width: var(--star-size, 24px);
    height: var(--star-size, 24px);
  }

  .ui-rate__star--hovered {
    cursor: pointer;
  }

  .ui-rate__star-gradient {
    --icon-start-color: #{$color--basic-blue};
    --icon-end-color: #{$color--basic-dark-gray};
  }

  .ui-rate__rate {
    font-size: 13px;
    color: $color--basic-dark-gray;
  }

  .ui-rate__rate-descriptions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 500;
    font-size: 11px;
    margin-top: 8px;
  }
</style>
